/*
* the inlineDialog width is 496px, minus 48px padding
* labels get 170px width of which 16px of right padding
* filters get 496 - 48 - 170 = 278px width
*/
.filterButtonWrapper > button {
	text-align: left;
	width: 278px;
}
